/**
 * Geolocation detection utility
 * Used to detect if user is from restricted regions
 */

/**
 * Detect user location using ipapi.co API
 * @returns {Promise<Object|null>} - Location information
 */
async function detectLocationByAPI() {
  try {
    const response = await fetch('https://ipapi.co/json/')
    const data = await response.json()
    
    return {
      country: data.country_code,
      countryName: data.country_name,
      region: data.region,
      city: data.city,
      ip: data.ip
    }
  } catch (error) {
    console.error('Geolocation detection failed:', error)
    return null
  }
}

/**
 * Check if user is from a blocked region
 * @returns {Promise<boolean>} - Whether the region is blocked
 */
export async function isRegionBlocked() {
  try {
    const location = await detectLocationByAPI()
    if (location) {
      // Check if user is from mainland China
      return location.country === 'CN'
    }
    
    return false
  } catch (error) {
    console.error('Region detection failed:', error)
    // If detection fails, allow access by default (avoid false positives)
    return false
  }
}

/**
 * Get user location information
 * @returns {Promise<Object|null>} - Location information
 */
export async function getUserLocation() {
  try {
    const location = await detectLocationByAPI()
    return location
  } catch (error) {
    console.error('Failed to get location:', error)
    return null
  }
}

export default {
  isRegionBlocked,
  getUserLocation
}
